import script from "./defaultKeywordComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./defaultKeywordComponent.vue?vue&type=script&setup=true&lang=js"

import "./defaultKeywordComponent.vue?vue&type=style&index=0&id=b9cce30a&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9cce30a"]])

export default __exports__